import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { formatDate } from '@/lib/format';
import { toast } from 'sonner';

export const AdminPlanExceptionsCard = () => {
  const [items, setItems] = useState([]);
  const [sellerId, setSellerId] = useState('');
  const [busy, setBusy] = useState(false);

  const load = () => api.get('/admin/plan-exceptions').then(({ data }) => setItems(data.items || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const call = async (fn, ok) => {
    setBusy(true);
    try { await fn(); toast.success(ok); setSellerId(''); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Error'); }
    finally { setBusy(false); }
  };
  const grant = () => call(() => api.post(`/admin/sellers/${sellerId.trim()}/plan-exception`, { note: 'Otorgada desde el panel' }), 'Excepción otorgada');
  const revoke = (id) => {
    if (!window.confirm('¿Retirar la excepción PRO permanente? El vendedor deberá elegir y pagar una modalidad para seguir vendiendo.')) return;
    call(() => api.delete(`/admin/sellers/${id}/plan-exception`), 'Excepción retirada');
  };

  return (
    <div className="mt-6 border border-slate-200 bg-white p-5" data-testid="admin-plan-exceptions-card">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Excepciones · PRO permanente sin costo</div>
      <div className="mt-3 divide-y divide-slate-100">
        {items.length === 0 && <div className="py-2 text-sm text-slate-500">Sin excepciones activas</div>}
        {items.map((it) => (
          <div key={it.user_id} className="py-2 flex items-center gap-3 text-sm" data-testid={`admin-plan-exception-${it.user_id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-900 truncate">{it.business_name || it.user_id}</div>
              <div className="text-xs text-slate-500">{it.user_id} · desde {formatDate(it.plan_exception?.granted_at)} · {it.plan_exception?.note}</div>
            </div>
            <Button size="sm" variant="outline" className="rounded-none" disabled={busy}
              onClick={() => revoke(it.user_id)} data-testid={`admin-plan-exception-revoke-${it.user_id}`}>Retirar</Button>
          </div>
        ))}
      </div>
      <div className="mt-3 flex gap-2">
        <Input value={sellerId} onChange={(e) => setSellerId(e.target.value)} placeholder="ID del vendedor (user_...)"
          className="rounded-none" data-testid="admin-plan-exception-seller-input" />
        <Button className="rounded-none bg-slate-900 hover:bg-slate-800" disabled={busy || !sellerId.trim()}
          onClick={grant} data-testid="admin-plan-exception-grant-btn">Otorgar</Button>
      </div>
    </div>
  );
};
